<template>
    <nav class="navbar navbar-expand navbar-light pl-0 bg-white py-3">
        <div class="collapse navbar-collapse" id="navbarNav">
            <IconButton icon="bars" :class="this.$route.name === 'sales/newSale' ? 'd-xl-none' : 'd-lg-none'" variant="light" size="md" :do-action="showSidebar"/>

            <ul v-if="$route.name === 'home'" class="navbar-nav">
                <li class="nav-item">
                    <router-link class="nav-link" :active-class="'text-primary'" :to="getLangUrl('')" exact>
                        <IconButton icon="home" variant="primary" class="nav-item d-sm-none"/>
                        <span class="d-none d-sm-block font-light">
                    {{ $t('home') }}
                </span>
                    </router-link>
                </li>
                <li v-if="$route.name !== 'home'" class="nav-item">
                    <router-link class="nav-link" :active-class="'text-primary'" :to="getLangUrl('products')">
                        <font-awesome-icon :icon="['fas', 'shopping-bag']" size="1x"/>
                        {{ $t('product.title') }}
                    </router-link>
                </li>
                <li v-if="$route.name !== 'home'" class="nav-item d-none d-md-block">
                    <router-link class="nav-link" :active-class="'text-primary'" :to="getLangUrl('services')">
                        <font-awesome-icon :icon="['fas', 'users-cog']" size="1x"/>
                        {{ $t('service.title') }}
                    </router-link>
                </li>
                <li v-if="$route.name !== 'home'" class="nav-item">
                    <router-link class="nav-link" :active-class="'text-primary'" :to="getLangUrl('sales/sale')">
                        <font-awesome-icon :icon="['fas', 'shopping-cart']" size="1x"/>
                        {{ $t('sale.title') }}
                    </router-link>
                </li>
                <li v-if="$route.name !== 'home'" class="nav-item">
                    <router-link
                        class="nav-link"
                        :active-class="'text-primary'"
                        :to="getLangUrl('login')"
                        v-if="!isAuthenticated">
                        <IconButton icon="sign-in-alt" variant="primary" class="nav-item d-sm-none"/>
                        <span class="d-none d-sm-block"> {{ $t('login.title') }} </span>
                    </router-link>
                    <router-link class="nav-link" :to="$i18nHelper.getUrl('logout')" v-if="isAuthenticated && getUser.person.employeeInformation === null">
                        <IconButton icon="sign-out-alt" variant="primary" class="nav-item d-sm-none"/>
                        <span class="d-none d-sm-block">
                    <font-awesome-icon :icon="['fa', 'sign-out-alt']" size="1x"/>
                    {{ $t('login.logout') }}
                </span>
                    </router-link>
                </li>
            </ul>

            <BreadcrumbRow v-else :items="breadcrumbItems" />

            <div class="flex absolute right-4">
                <div v-if="isFullscreen && isShow" class="full-screen-icon bg-lightGray h-10 w-12 rounded flex justify-center items-center">
                    <font-awesome-icon class="full-screen-icon" @click="openFullScreen" :icon="['fa', 'compress']"
                                       size="1x"/>
                </div>
                <div v-if="!isFullscreen && isShow" class="full-screen-icon bg-lightGray h-10 w-12 rounded flex justify-center items-center">
                    <img src="/images/expand.png" class="h-5" alt="" @click="openFullScreen">
                </div>

                <div v-if="isShow && $store.getters.isAuthenticated" class="ml-3 h-10 rounded mt-0.5 w-12 bg-lightGray flex justify-center items-center">
                    <img src="/images/refresh-double.png" class="h-6 cursor-pointer" alt="" @click="reload">
                </div>

                <div class="d-none d-sm-block px-2 ml-3 h-10 rounded mt-0.5 w-20 bg-lightGray flex justify-center items-center">
                    <LanguageSwitcher />
                </div>

                <div class="h-10 w-12 mt-0.5 ml-3 flex items-center justify-center rounded bg-lightGray cursor-pointer">
                    <!--  notification bell  -->
                    <span
                        v-if="$route.name !== 'login' && $route.name !== 'company/add' && $route.name !== 'forgot' && $route.name !== 'reset'"
                        @click="showModal"
                    >
                        <span class="position-relative">
                    <img src="/images/IconBell.png" alt="icon_bell" >
                    <span
                        class="position-absolute"
                        style="background-color: red; color: white; font-weight: bolder; left: 12px; top: -10px; font-size: 11px; border-radius: 50%; height: 18px; width: 18px"
                        v-if="getProductsIsNotifyTotalCount + getProductsExpiredTotalCount > 0">

                        <span class="position-absolute" style="left: 2px; top: 1px;">
                            {{ getProductsIsNotifyTotalCount + getProductsExpiredTotalCount }}
                        </span>
                    </span>
                </span>
                    </span>
                </div>
                <div
                    v-if="$store.getters.isAuthenticated"
                    class="cursor-pointer h-10 w-52 mt-0.5"
                    @click="showModalInfo"
                >
                    <div class="grid grid-cols-3">
                        <div class="col-span-1 text-center">
                            <img v-if="getUser.person.image" :src="appUrl + getUser.person.image.contentUrl" alt="" class="h-10 rounded-full">
                            <img v-else src="/images/employee.png" class="h-10" alt="">
                        </div>
                        <div v-if="getUser.id" class="col-span-2 bg-lightGray rounded h-10 px-1">
                            <div class="text-main text-xs text-center mt-1">{{ getUserName(getUser.person) }}</div>
                            <div class="text-main text-xs text-center font-bold">{{ getUserRoleName(getUser) }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <b-modal id="productsInWarehousesIsNotify" hide-footer size="xl">
                <!-- Modal body -->
                <span class="modal-header p-0 pb-3">
                        <b-button :variant="amountBtnColor" @click="amount"> {{
                                $t('product.productAmount')
                            }} </b-button>
                        <b-button :variant="expiredBtnColor" class="float-right"
                                  @click="expired">{{ $t('product.productExpired') }}</b-button>
                        <b-button :variant="repayBtnColor" class="float-right" @click="repay">{{
                                $t('debtPayingTime')
                            }}</b-button>
                    </span>
                <div class="modal-body p-0">
                    <table class="table" v-if="notifyMenu === 'amount'">
                        <thead>
                        <tr>
                            <th> #</th>
                            <th>{{ $t('product.name') }}</th>
                            <th>{{ $t('warehouse.title') }}</th>
                            <th>{{ $t('warehouse.remainder') }}</th>
                            <th>{{ $t('delete') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(product, index ) of getProductsIsNotify" :key="index">
                            <td> {{ index + 1 }}</td>
                            <td>
                                <router-link
                                    @click.native="check"
                                    :to="$i18nHelper.getUrl('products/' + product.product.id +'/purchase/warehouse/' + product.warehouse.id + '/product/' + product.product.name)">
                                    {{ product.product.name }}
                                </router-link>
                            </td>
                            <td>{{ product.warehouse.name }}</td>
                            <td>{{ product.amount }} {{ showUnitOfMeasure(product.product.unitOfMeasure) }}</td>
                            <th v-if="product.amount === 0">
                                <button
                                    type="button"
                                    class="close float-none"
                                    style="color: #6f42c1; font-size: 28px"
                                    @click="showModalIsNotify(product.id)"
                                >
                                    &times;
                                </button>
                            </th>
                            <td v-else style="padding-left: 18px">-</td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="table" v-if="notifyMenu === 'expired'">
                        <thead>
                        <tr>
                            <th class="d-none d-lg-table-cell"> #</th>
                            <th>{{ $t('product.name') }}</th>
                            <th>{{ $t('product.datePurchase') }}</th>
                            <th>{{ $t('product.expired') }}</th>
                            <th>{{ $t('warehouse.remainder') }}</th>
                            <th>{{ $t('warehouse.title') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(purchase, index ) of getProductsExpired" :key="index">
                            <td class="d-none d-lg-table-cell"> {{ index + 1 }}</td>
                            <td>{{ purchase.product.name }}</td>
                            <td>{{ convertDateAnnouncement(purchase.createdAt) }}</td>
                            <td>{{ convertDateAnnouncement(purchase.shelfLife) }}</td>
                            <td>{{ purchase.amount }} {{ showUnitOfMeasure(purchase.product.unitOfMeasure) }}</td>
                            <td>{{ purchase.warehouse.name }}</td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="table" v-if="notifyMenu === 'repay'">
                        <thead>
                        <tr>
                            <th class="d-none d-lg-table-cell"> {{ $t('printView.receipt') }}</th>
                            <th>{{ $t('customer.title') }}</th>
                            <th>{{ $t('sale.sum') }}</th>
                            <th>{{ $t('debt') }}</th>
                            <th>{{ $t('debtPayingTime') }}</th>
                            <th>{{ $t('incomeAndOutcome.Status') }}</th>
                            <th>{{ $t('actions') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(sale, index ) in getNearlyRepayingSales" :key="index">
                            <td class="d-none d-lg-table-cell" :style="`color: ${repayColor(sale)}`"> {{
                                    sale.id
                                }}
                            </td>
                            <td :style="`color: ${repayColor(sale)}`">{{ getCustomerName(sale) }}</td>
                            <td :style="`color: ${repayColor(sale)}`">
                                {{ showCurrencyById(sale.currency.id, sale.totalPurchaseAmount) }}
                            </td>
                            <td :style="`color: ${repayColor(sale)}`">{{
                                    showCurrencyById(sale.currency.id, parseFloat(sale.totalPurchaseAmount) - parseFloat(sale.payedAmount))
                                }}
                            </td>
                            <td :style="`color: ${repayColor(sale)}`">
                                <div>{{ dateFormat(sale.repaymentDate) }}</div>
                            </td>
                            <td :style="`color: ${repayColor(sale)}`">{{ getStatus(sale) }}</td>
                            <td :style="`color: ${repayColor(sale)}`">
                                <font-awesome-icon style="color: #6f42c1; cursor: pointer" @click="getDetails(sale)"
                                                   :icon="['fa', 'eye']" size="1x"/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </b-modal>
            <b-modal id="delete-isNotify-modal" hide-footer>
                <!-- Modal body -->
                <div class="modal-body">
                    {{ $t('productsInWarehouse.deleteIsNotify') }}
                </div>
                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn danger" data-dismiss="modal" @click="deleteIsNotify">
                        {{ $t('yes') }}
                    </button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal" @click="cancelDelete">
                        {{ $t('no') }}
                    </button>
                </div>
            </b-modal>
            <b-modal id="user-info" class="position-fixed modal-user" hide-footer>
                <!-- Modal body -->
                <div class="grid grid-cols-10">
                    <div class="col-span-4 flex justify-center items-center">
                        <img v-if="getUser.person.image" :src="appUrl + getUser.person.image.contentUrl" alt="" class="h-32 rounded-full">
                        <img v-else src="/images/employee.png" class="h-32" alt="">
                    </div>
                    <div class="col-span-6 px-3">
                        <div class="mt-4 text-gray-600">
                            {{ getUserName(getUser.person) }}
                            <img src="/images/edit.png" @click="toEdit" alt="" class="h-5 absolute right-4 cursor-pointer" />
                        </div>
                        <div v-if="getUser.id" class="mt-2 text-gray-600 font-bold">{{ $t('employee.position') }}: {{ getUserRoleName(getUser) }}</div>
                    </div>
                </div>

                <div class="grid grid-cols-1 mb-6 mt-3">
                    <div>
                        <table class="w-full text-gray-600">
                            <tr class="h-11">
                                <td>{{ $t('company.registeredDate') }}</td>
                                <td>{{ dateFormat(getUser.createdAt) }}</td>
                            </tr>
                            <tr class="h-11">
                                <td>{{ $t('company.name') }}</td>
                                <td>{{ getUser.person.company.name }}</td>
                            </tr>
                            <tr class="h-11">
                                <td>{{ $t('user.email') }}</td>
                                <td>{{ getUser.email }}</td>
                            </tr>
                            <tr class="h-11">
                                <td>{{ $t('company.telephone') }}</td>
                                <td>{{ getUser.person.telephone }}</td>
                            </tr>
                            <tr v-if="!getUser.person.employeeInformation" class="h-11">
                                <td>{{ $t('companyRequisites.legalAddress') }}</td>
                                <td>{{ getUser.person.company.legalAddress ? getUser.person.company.legalAddress : '-' }}</td>
                            </tr>
                            <tr v-if="!getUser.person.employeeInformation" class="h-11">
                                <td>{{ $t('companyRequisites.physicalAddress') }}</td>
                                <td>{{ getUser.person.company.physicalAddress ? getUser.person.company.physicalAddress : '-' }}</td>
                            </tr>
                            <tr v-if="!getUser.person.employeeInformation" class="h-11">
                                <td>{{ $t('company.employeesCount') }}</td>
                                <td>{{ getEmployeesCount }}</td>
                            </tr>
                            <tr class="h-11 font-bold">
                                <td>{{ $t('login.logout') }}</td>
                                <td> <font-awesome-icon :icon="['fa', 'sign-out-alt']" size="lg" class="cursor-pointer" @click="$i18nHelper.toUrl('logout')" /></td>
                            </tr>
                        </table>
                    </div>
                </div>
            </b-modal>
        </div>
    </nav>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import LanguageSwitcher from "./LanguageSwitcher";
import IconButton from "./IconButton";
import accessMixin from "@/mixin/accessMixin";
import sizeClassesMixin from "@/components/html/mixin/sizeClassesMixin";
import displayClassesMixin from "@/components/html/mixin/displayClassesMixin";
import store from "@/store/main";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import BreadcrumbRow from "@/components/BreadcrumbRow.vue";

export default {
    name: "MainMenu",
    components: {BreadcrumbRow, IconButton, LanguageSwitcher},
    mixins: [dateFormattingMixin, currencyFormatMixin, accessMixin, sizeClassesMixin, displayClassesMixin],
    data() {
        return {
            appUrl: process.env.VUE_APP_API_URL,
            breadcrumbItems: [],
            hasNeedReload: true,
            notifyMenu: 'amount',
            isFullscreen: false,
            colorBell: '#6f42c1',
            isShow: false,
            amountBtnColor: "primary",
            expiredBtnColor: "",
            repayBtnColor: "",
            productsInWarehousesId: 0
        }
    },
    computed: {
        ...mapGetters([
            "getNearlyRepayingSales",
            'isAuthenticated',
            'getProductsInWarehouses',
            'getProductsIsNotify',
            'getProductsIsNotifyTotalCount',
            'getProductsExpired',
            'getProductsExpiredTotalCount',
            'getUser',
            'getBreadcrumbItems',
            'getEmployeesCount'
        ]),
    },
    methods: {
        ...mapActions([
            'fetchRepaymentDateSales',
            'fetchProductsIsNotify',
            'fetchProductsExpired',
            'putProductInWarehouseIsNotify',
            'fetchAllProductsInWarehouses',
            'fetchAllCustomers',
            'fetchSuppliers',
            'fetchProductsSearch',
            'fetchAllServices',
            'fetchEmployeesCount'
        ]),
        getUserRoleName(user) {
            if (user.person.employeePositions.length) {
                return user.person.employeePositions[0].name
            }

            for (let role of user.roles) {
                switch (role) {
                    case 'ROLE_CEO':
                        return this.$t('company.owner')
                }
            }
        },
        getUserName(person) {
            return person.givenName + ' ' + person.familyName
        },
        showModalInfo() {
            this.$bvModal.show('user-info')
        },
        toEdit() {
            if (this.$route.name !== 'company/edit') {
                this.$i18nHelper.toUrl('company/edit')
            }

            this.$bvModal.hide('user-info')
        },
        getDetails(sale) {
            this.cancelShowModal()

            let url = '&'

            if (sale.customer.isCompany) {
                url += 'companyName=' + sale.customer.customerCompany.name
            } else {
                url += 'personGivenName=' + sale.customer.person.givenName + '&personFamilyName=' + sale.customer.person.familyName
            }

            this.$i18nHelper.toUrl('sales/transactions?id=' + sale.id + url)
        },
        getCustomerName(sale) {
            return sale.customer.isCompany ? sale.customer.customerCompany.name :
                sale.customer.person ? sale.customer.person.givenName + ' ' + sale.customer.person.familyName : ''
        },
        getStatus(sale) {
            let debtDay = this.calculateDebtDay(sale)
            return debtDay > 0 ?
                this.$t('debtPayingTimeNotCome') :
                debtDay === 0 ? this.$t('debtPayingTimeCome') :
                    this.$t('debtPayingTimeGone')
        },
        calculateDebtDay(sale) {
            const time = new Date(sale.repaymentDate) - Date.now();
            return Math.ceil(Math.ceil((time / 1000) / (3600 * 24)));
        },
        reload() {
            if (!this.hasNeedReload) {
                return
            }

            this.$i18nHelper.flash(this.$t('refreshInfo'), 'info')
            this.$store.state.productsInWarehouses.productsInWarehouses.isNeedFetch = true
            this.$store.state.service.services.isNeedFetch = true
            this.$store.state.supplier.suppliers.isNeedFetch = true
            this.$store.state.customer.customers.isNeedFetch = true
            this.$store.state.product.products.isNeedFetch = true

            this.fetchAllProductsInWarehouses()
            this.fetchAllCustomers()
            this.fetchSuppliers(null)
            this.fetchProductsSearch(null)
            this.fetchAllServices()

            this.hasNeedReload = false
            setTimeout(() => this.hasNeedReload = true, 8000)
        },
        deleteIsNotify() {
            this.putProductInWarehouseIsNotify({id: this.productsInWarehousesId, alertAmount: null})
                .then(() => {
                    this.productsInWarehousesId = 0
                    this.$bvModal.hide('delete-isNotify-modal')
                    this.fetchProductsIsNotify()
                    this.isCheckedAll = false
                })
        },
        showModalIsNotify(id) {
            this.productsInWarehousesId = id
            this.$bvModal.show('delete-isNotify-modal')
        },
        cancelDelete() {
            this.$bvModal.hide('delete-isNotify-modal')
            this.productsInWarehousesId = 0
            this.isCheckedAll = false
        },
        amount() {
            this.notifyMenu = 'amount'
            this.amountBtnColor = "primary"
            this.expiredBtnColor = ""
            this.repayBtnColor = ""
        },
        expired() {
            this.notifyMenu = 'expired'
            this.amountBtnColor = ""
            this.expiredBtnColor = "primary"
            this.repayBtnColor = ""
        },
        repay() {
            this.notifyMenu = 'repay'
            this.amountBtnColor = ""
            this.expiredBtnColor = ""
            this.repayBtnColor = "primary"
        },
        repayColor(sale) {
            let debtDay = this.calculateDebtDay(sale)
            return debtDay < 0 ? '#FF2020' : ''
        },
        resize() {
            this.isShow = window.innerWidth > 676
        },
        showModal() {
            if (this.getProductsIsNotifyTotalCount > 0 || this.getProductsExpiredTotalCount > 0) {
                this.$bvModal.show('productsInWarehousesIsNotify')
            }
        },
        cancelShowModal() {
            this.$bvModal.hide('productsInWarehousesIsNotify')
        },
        getLangUrl(url) {
            return this.$i18nHelper.getUrl(url)
        },
        showSidebar() {
            this.$root.showSidebar = true
        },
        async openFullScreen() {
            await this.$fullscreen.toggle()

            this.isFullscreen = !this.$fullscreen.isFullscreen
        },
        check() {
            if (this.$route.name === "products/purchase/warehouse") {
                this.$router.go(0)
            }

            this.cancelShowModal()
        },
        showUnitOfMeasure(unit) {
            if (unit === undefined) {
                return ''
            }

            if (Object.prototype.hasOwnProperty.call(this.$i18n.messages.en.unitOfMeasure, unit)) {
                return this.$t('unitOfMeasure.' + unit)
            }

            return unit
        },
        convertDateAnnouncement(inputFormat) {
            function pad(s) {
                return (s < 10) ? '0' + s : s;
            }

            let d = new Date(inputFormat)
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('.')
        },
    },
    watch: {
        'getProductsIsNotify'() {
            if (this.getProductsIsNotify.length > 0) {
                this.colorBell = 'red'
            }
        },
        getBreadcrumbItems: {
            deep: true,
            handler: function (newVal) {
                this.breadcrumbItems = newVal
            }
        },
        getUser: {
            deep: true,
            handler: function (newVal) {
                if (this.isAuthenticated) {
                    setTimeout(() => {
                        this.fetchEmployeesCount(newVal.person.company.id)
                    }, 2000)
                } else {
                    this.$root.showOverlay = false
                }
            }
        }
    },
    mounted() {
        this.resize()
        this.$nextTick(() => {
            window.addEventListener('resize', this.resize);
        })

        if (store.getters.getUserRoles.length !== 0 && this.$route.name !== 'forgot' && this.$route.name !== 'reset') {
            // this.fetchProductsIsNotify()
            // this.fetchRepaymentDateSales()
            // this.fetchProductsExpired()
        }

        this.breadcrumbItems = this.getBreadcrumbItems
    },
}
</script>

<style scoped>
.modal-user {
  z-index: 100;
}

.full-screen-icon {
    font-size: 20px !important;
    color: #6E43C4;
    margin-top: 2px;
    cursor: pointer;
}

.refresh {
    font-size: 20px !important;
    margin-top: 11px;
    color: #6E43C4;
    box-shadow: none;
    cursor: pointer;
}

table tr {
    border-bottom: 1px solid #eaeaea;
}

</style>
